var exports = {
  "i": "xaee3c4fa--811f07--wrapper",
};

module.exports = exports;
